import { trackWithGoogleAnalytics } from '../../shared/analytics/shared/trackers/trackWithGoogleAnalytics';
import { ILoyaltyDetailsResponse } from '../../shared/api/gateway/types/ICustomerDetailsResponse';

export const setLoyaltyInfoProperties = (
	hasLoyaltyAccount: boolean,
	loyaltyDetails: ILoyaltyDetailsResponse | undefined = undefined,
) => {
	const tier = loyaltyDetails?.tier;
	const points = loyaltyDetails?.redeemablePoints;

	trackWithGoogleAnalytics('set', 'user_properties', {
		has_loyalty_account: hasLoyaltyAccount,
		loyalty_tier: tier,
		loyalty_points: points,
	});
};
